const photoEnhancer = {
  UnlimitedNumberOfSheets: '無限數量的圖像',
  SupportAllModels: '支援所有模型',
  MagnificationAllX: '放大倍數：1X、2X、4X、8X',
  OutputImageFormatMore: '輸出圖像格式：JPG、PNG、TIFF',
  NoWatermark: '無水印',
  CancelAtAnytime: '隨時取消',
  HighPriorityProcessingSpeed: '高優先處理速度',
  HitPawAIPhotoEnhancer: 'HitPaw AI 修復圖像畫質',
  weekDayPrice: 'NT$38.43',
  WeekTotalPrice: 'NT$269.00',
  MonthDayPrice: 'NT$19.30',
  MonthTotalPrice: 'NT$579.00',
  YearDayPrice: 'NT$10.93',
  YearTotalPrice: 'NT$3990.00',
  Day: '日',
  Monthly: '月',
  Weekly: '周',
  Yearly: '年',
};

export default photoEnhancer;
